import { css, Theme } from "@emotion/react";

export const table = (theme: Theme) =>
    css({
        tableLayout: "fixed",
        width: 0,
        borderCollapse: "collapse",
        borderWidth: 0,
        borderColor: theme.candy.tables.border.color,
    });

export const sidebar = (theme: Theme) =>
    css({
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,

        td: {
            padding: "0 5px",
        },
    });

export const sidebarContainer = (theme: Theme) =>
    css({
        paddingLeft: 40,
        marginLeft: -40,
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,
        position: "absolute",
        zIndex: 100,
    });
